import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface RescheduleState {
  purchase?: core.PastPurchase;
  requestInProgress: boolean;
  token?: string;
}

/**
 * exported for testing
 */
export const initialState: RescheduleState = {
  purchase: undefined,
  requestInProgress: false,
  token: undefined,
};

export default function reducer(state = initialState, action: BaseTockAction): RescheduleState {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.RESCHEDULE_PURCHASE_UPDATE: {
      return {
        ...state,
        purchase: payload.purchase,
        token: payload.token,
      };
    }
    case AppConstants.RESCHEDULE_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case AppConstants.RESCHEDULE_DONE:
    case AppConstants.RESCHEDULE_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case AppConstants.RESCHEDULE_CLEAR: {
      return {
        ...state,
        purchase: undefined,
        token: undefined,
      };
    }
    default:
      return state;
  }
}
